import { render } from "./CollectionTokensSet.vue?vue&type=template&id=bf3757b0"
import script from "./CollectionTokensSet.vue?vue&type=script&lang=js"
export * from "./CollectionTokensSet.vue?vue&type=script&lang=js"

import "./CollectionTokensSet.vue?vue&type=style&index=0&id=bf3757b0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__